module.exports = __webpack_public_path__ + "static/media/navigation-arrow-left.bf4a908b.svg";